<template>
  <main class="main home-page">
    <img
      src="@/assets/hero_ellipse.png"
      alt=""
      class="hero-section-background-blur"
    />
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper home">
          <div class="left">
            <div class="title big">
              <p v-html="translatedText"></p>
            </div>
            <div class="desc">
              {{ $t(`c4skins offers a wide selection of Rust skins`) }}
            </div>
          </div>
          <div class="right">
            <div class="img-container">
              <img src="./../assets/weapon.png" class="img" />
            </div>
          </div>
        </div>
        <Features />
      </div>

      <ImproveSection
        :title="$t('DOTA 2 AND RUST SKINS')"
        :description="$t('One platform to shop all the skins for both of your favourite games')"
        leftImage="improve_section_left_bottom.png"
        rightImage="improve_section_right_top.png"
      />

      <section class="section last-sales-section">
        <LastSales
          :currencySymbol="currencySymbol"
          @goToProduct="goToProduct"
        />
      </section>

      <div class="section arrivals-section sale-section">
        <div class="wrapper">
          <div class="top">
            <div class="title">{{ $t("Most Popular") }}</div>
            <router-link to="/products/dota2" class="link">
              <span>{{ $t("View all") }}</span>
              <img src="./../assets/white-arrow.svg" class="img" />
            </router-link>
          </div>
          <SlickItem
            v-if="$parent.newArrivals.length"
            :list="$parent.newArrivals"
            :tag="''"
            :addToCartChosenItem="addToCartChosenItem"
            @addToCart="addToCart"
            @goToProduct="goToProduct"
            :currency="currencySymbol"
          />
        </div>
      </div>
      <div class="section more-offers-section wrapper">
        <img src="./../assets/more-offers.png" class="img" />
        <router-link to="/products" class="more-offers-icon">
          <img src="./../assets/more-offers-icon.svg" />
        </router-link>
        <div class="">
          <div class="left">
            <div class="title big">
              {{ $t(">1k Offers for both Rust and Dota") }}
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="wrapper more-offers-benefits">
          <div class="more-offers-card">
            <p>{{ $t("You may pick from a wide variety of skins") }}.</p>
          </div>
          <div class="more-offers-card">
            <p>
              {{
                $t(
                  "Get the latest items and skins at low prices once they are released"
                )
              }}.
            </p>
          </div>
          <div class="more-offers-card">
            <p>{{ $t("You may get exclusive, rare skins and items") }}.</p>
          </div>
        </div>
      </div>

      <ImproveSection
        :title="$t('Improve your inventory with c4skins')"
        leftImage="improve_section_left_bottom_2.png"
        rightImage="improve_section_right_top_2.png"
        customClass="second-improve-section"
      />

      <FaqSection
        title="Q&A"
      />

      <section id="contact-us" class="section contact-us-section">
        <div class="wrapper">
          <div class="title">{{ $t("Contact Us") }}</div>
          <div class="contact-grid">
            <div class="contact-item">
              <div class="desc">{{ $t("Business information") }}</div>
              <div class="value pre-line">{{ $parent.footerRequisites }}</div>
            </div>
            <div class="contact-item" v-if="$parent.footerSupportEmail">
              <div class="desc">{{ $t("Support email") }}</div>
              <a class="value" :href="`mailto:${$parent.footerSupportEmail}`">
                {{ $parent.footerSupportEmail }}
              </a>
            </div>
            <div class="contact-item">
              <div class="desc">{{ $t("Working hours") }}</div>
              <div class="value">{{ $t("working_hours") }}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>
<script>
import SlickItem from "../components/SlickItem.vue";
import Features from "../components/Features.vue";
import ImproveSection from "../components/ImproveSection.vue";
import LastSales from "../components/LastSales.vue";
import FaqSection from "../components/FaqSection.vue";
export default {
  name: "Home",
  props: ["addToCartChosenItem", "currency", "currencySymbol"],
  components: {
    SlickItem,
    Features,
    ImproveSection,
    LastSales,
    FaqSection,
  },
  data: function () {
    return {
      imgDomain: "",
    };
  },
  computed: {
    translatedText() {
      return this.$t("buy_skins_text", {
        firstTitle: `<span class="cadet-blue">Rust</span>`,
        secondTitle: `<span class="orange">DOTA2</span>`,
      });
    },
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
  methods: {
    goToProduct(item) {
      this.$emit("goToProduct", item);
    },
    addToCart(item, id, item_type) {
      this.$emit("addToCart", item, id, item_type);
    },
  },
};
</script>

<style lang="scss" scoped>
.second-improve-section {
  background: #56a7a1;
}

.contact-us-section {
  padding-top: 80px;
}

.contact-us-section .wrapper {
  text-align: left;
}

.contact-us-section .title {
  margin-bottom: 24px;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.contact-item {
  background: var(--bg-second-black);
  border-radius: 8px;
  padding: 24px;
}

.contact-item .desc {
  margin-bottom: 12px;
  color: #9898A9;
}

.contact-item .value {
  color: #fff;
  font-weight: 600;
  line-height: 24px;
}

.contact-item a.value {
  color: #EC7633;
}

.pre-line {
  white-space: pre-line;
}

@media screen and (max-width: 768px) {
  .contact-grid {
    grid-template-columns: 1fr;
  }
}
</style>
